import "bootstrap-icons/font/bootstrap-icons.css";
import { LinkButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";
import { handleOpenPdf } from "utils";
import AccordionGeneral from "components/accordion/AccordionGeneral";
import { virtualbankingList } from "constants/virtualbanking";
import { ASSETS_BASE_URL } from "constants";

function VirtualBanking() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Virtual Banking"
          title={`<span className="jumbotron-subtitle-2">
                alrajhi
              </span>@24seven`}
          buttonText="Talk to us"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Why wait in line when you can bank online? With alrajhi bank
              Malaysia Internet Banking, you can enjoy a seamless, secure, and
              convenient banking experience, anytime, anywhere. Our digital
              banking services are not only safe and reliable but also available
              24/7, giving you the freedom to manage your finances on your
              terms.
            </p>
            <p>
              We've designed the alrajhi@24seven app to give you more time for
              what matters most. With features such as:
            </p>
            <p>
              <li>
                {" "}
                24/7 Account-i Access: Manage your accounts and portfolios,
                check balances, and view transaction history at any time.
              </li>
              <li>
                {" "}
                Funds Transfer: Transfer money between your accounts or to other
                banks effortlessly.
              </li>
              <li>
                {" "}
                Bill Payments: Pay your bills with just a few taps, saving you
                time and hassle.
              </li>
              <li>
                Secure Login: Experience peace of mind with our enhanced
                security measures.
              </li>
            </p>
            <p>
              Enjoy flexible access to your money, whether you're at home, at
              work, or on the go. With alrajhi@24seven, you can bank the way you
              want, when you want.
            </p>
            {/* <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            /> */}
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-3">
                  <b> 24-hour access</b> to alrajhi bank Malaysia accounts
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-3">
                  <b>No more long queues</b> or lengthy waiting time
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-3">
                  Convenience – <b>anytime anywhere</b>
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-3">
                  <b>Paperless</b> statement and receipt
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-3">
                  <b>No more delay</b> in bill payments
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="col-12 container">
        <AccordionGeneral list={virtualbankingList} />
      </div>

      <section className="section about container">
        <div
          className="row"
          style={{ justifyContent: "flex-start", alignContent: "flex-start" }}
        >
          <div className="col-xl-4">
            <h3>FAQ</h3>
          </div>
          <div className="col-xl-8">
            <p>
              For more information on alrajhi@24/7, please refer to this{" "}
              <a
                href="https://www.alrajhi24seven.com.my/iportalweb/iportal/html/HandyTips.html"
                target="blank"
              >
                FAQ
              </a>
              .
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div
          className="row"
          style={{ justifyContent: "flex-start", alignContent: "flex-start" }}
        >
          <div className="col-xl-4">
            <h3>To Apply</h3>
          </div>
          <div className="col-xl-8">
            <p>
              All you need to have is alrajhi bank Malaysia Debit Card-i to
              proceed for Internet Banking Registration! 
            </p>
            <p>
              {" "}
              <li>
                Click 
                <a
                  href="https://www.alrajhi24seven.com.my/iportalweb/iRetail@1"
                  target="blank"
                >
                  here
                </a>
                 to continue your registration process.
              </li>
              <li>
                Click 
                <a href="https://www.duitnow.my/" target="blank">
                  here
                </a>
                 for DuitNow details.
              </li>{" "}
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div
          className="row"
          style={{ justifyContent: "flex-start", alignContent: "flex-start" }}
        >
          <div className="col-xl-4">
            <h3>Disclaimer</h3>
          </div>
          <div className="col-xl-8">
            <p>
              1. alrajhi@24seven personal internet banking and mobile banking
              are available to alrajhi bank Malaysia account holders only. Terms
              and conditions apply.
            </p>
            <p>
              2. Mobile Banking requires you to download the Mobile Banking App
              and is only available for selected smartphone devices. Data
              charges may be charged by your service network provider if the
              mobile app is downloaded.
            </p>
            <p>
              3. alrajhi@24seven Mobile Banking App - get notified when a new
              version or update of our app is available. For critical updates,
              you may need to visit the Apple Store or Google Play Store that
              provides your mobile banking app device respectively.
            </p>
            <p>
              4. Routine or unscheduled maintenance may impact accessibility. 
            </p>
            <p>
              5. Interbank GIRO (IBG), JomPAY, Instant Credit Transfer and
              DuitNow and related marks and logos belong to Payment Networks
              Malaysia (PayNet).
            </p>
            <p>
              6. The debit card program is issued and administered by Al Rajhi
              Banking and Investment & Corporation (Malaysia) Bhd under license
              from Visa Inc. VISA and VISA PLUS are registered trademark of Visa
              International Service Association and is used by the issuer
              pursuant to license from Visa U.S.A Inc.
            </p>
            <p>
              7. Apple, the Apple logo, iphone and ipad are trademarks of Apple
              Inc., registered in the U.S. and other countries. App Store is a
              service mark of Apple Inc.
            </p>
            <p>8. Google Pay and Android is a trademark of Google Inc.</p>

            <div className="link-button-row">
              <LinkButton
                text="How to Register"
                onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/virtualbanking/1594093461_IBK_Registration.pdf`)}
              />

              <LinkButton
                text="Terms and Conditions"
                onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/virtualbanking/1614074199_alrajhi@24seven terms and conditions.pdf`)}
              />
              <LinkButton
                text="Interbank GIRO (IBG)"
                onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/virtualbanking/1594093494_Interbank GIRO (IBG).pdf`)}
              />
              <LinkButton text="JomPAY" onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/virtualbanking/JomPAY.pdf`)} />
              <LinkButton
                text="National Addressing Database (NAD) 
Terms and Conditions"
                onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/virtualbanking/1614072127_National Addressing Database (NAD) Terms and Conditions.pdf`)}
              />
              {/* <LinkButton
                text="Terms and Conditions -
Online Account Opening Promotion"  onClick={() => handleOpenPdf(tncpromo)}
              /> */}
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Let's connect! </h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
      {/* <MainFooter />
      <SubFooter /> */}
    </div>
  );
}

export default VirtualBanking;
